// Settings shared by the base tier (on the plan) and each premium tier.
export const TIER_SETTINGS_FIELDS = [
    'accrual_hours',
    'per_hours_worked',
    'rollover_enabled',
    'max_rollover_hours',
    'max_balance_hours',
    'max_accrued_per_year',
    'max_taken_per_year',
]

// When a premium tier starts, e.g. "2 years".
export function startsAt(tier) {
    const months = Number(tier.starts_after_months)
    if (months % 12 == 0) {
        const years = months / 12
        return `${years} ${years == 1 ? 'year' : 'years'}`
    }
    return `${months} ${months == 1 ? 'month' : 'months'}`
}
